























































































import Vue from 'vue'
import { Component, Prop, Watch, Emit } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'

import AppDialog from '@/components/AppDialog.vue'
import FoldingCard from '@/components/FoldingCard.vue'
import { Account } from '@/modules/Account/interfaces/account'
import CertificateOfInsuranceDialog from '@/modules/CertificateOfInsurance/scripts/certificate-dialog'

@Component({
  components: {
    FoldingCard,
    AppDialog
  }
})
export default class AccountDetailCertificate extends mixins(CertificateOfInsuranceDialog) {
  @Prop({ type: Object as () => Account }) readonly account!: Account

  headers = [
    { text: 'COI', value: 'coi' },
    { text: 'Revision Number', value: 'revisionNumber', width: 100 },
    { text: 'General Liability Policy', value: 'generalLiabilityPolicy', width: 180 },
    { text: 'Automobile Liability Policy', value: 'automobileLiabilityPolicy', width: 180 },
    { text: 'Actions', value: 'actions', sortable: false, width: 80 }
  ]

  accountId: number | null = null

  tableColumn = [
    { field: 'coi',
      title: 'COI',
      slots: { default: 'coi_default' },
      minWidth: 100,
      resizable: true
    },
    { field: 'generalLiabilityPolicy',
      title: 'General Liability Policy',
      slots: { default: 'general_policy' },
      width: 200,
      resizable: true
    },
    { field: 'automobilePolicy',
      title: 'Automobile Liability Policy',
      slots: { default: 'auto_policy' },
      width: 200,
      resizable: true
    },
    { field: 'umbrellaExcessLiabilityPolicy',
      title: 'Umbrella/Excess Liability Policy',
      slots: { default: 'umbrella_policy' },
      width: 220,
      resizable: true
    },
    { field: 'workersCompensationPolicy',
      title: 'Workers Compensation Policy',
      slots: { default: 'workers_policy' },
      width: 220,
      resizable: true
    },
    { field: 'otherPolicy',
      title: 'Other Policy',
      slots: { default: 'other_policy' },
      width: 200,
      resizable: true
    },
    { field: 'actions', title: 'Actions', slots: { default: 'action_default' }, fixed: 'right', width: 90 }
  ]

  get certificates () {
    return this.account.certificatesOfInsurance || []
  }

  routeTo (name: string, params: any) {
    this.$router.push({
      name,
      params
    })
  }

  routeToDetail (item: any) {
    return {
      name: 'CertificateOfInsuranceDetailDetail',
      params: {
        id: item.id,
        accountId: this.account.id,
        accountName: this.account.name
      }
    }
  }

  routeToPolicy (item: any) {
    return {
      name: 'PolicyDetailDetail',
      params: {
        id: item.id
      }
    }
  }

  newCertificateOfInsurance (e: Event) {
    e.preventDefault()
    e.stopPropagation()
    this.accountId = Number(this.account.id)
    this.showCertificateEditDialog(e)
  }

  async deletePolicyConfirm () {
    await this.deleteCertificatePost()
    this.onFormSuccess()
  }

  clearForm () {
    this.accountId = null
    this.hideCertificateEditDialog()
  }

  @Emit('refresh')
  onFormSuccess () {
    // do nothing
  }
}
